import { cloneDeep } from 'lodash'

import { fallbackConditionsValidator, payloadValidator } from '@sigma-frontend-libs/commons'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Fallbacks',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    defaultValue: {
      type: Object,
      default: () => {
        return {}
      }
    },

    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },

    applyingTemplate: {
      type: Boolean,
      default: false
    },

    service: {
      type: String,
      default: undefined
    }
  },

  computed: {
    isValidPayload() {
      return payloadValidator(this.proxy.payload, this.proxy.type)
    },

    $_disabled() {
      return this.disabled || this.proxy.fallbacks?.length >= 3
    },

    isValidFallbacks() {
      if (!this.proxy?.fallbacks) {
        return []
      }

      return this.proxy.fallbacks.map(({ type, payload, $options }) => {
        return payloadValidator(payload, type) && fallbackConditionsValidator($options)
      })
    }
  },

  methods: {
    add() {
      this.proxy.fallbacks.push(cloneDeep(this.defaultValue))
    },
    remove(index) {
      this.proxy.fallbacks.splice(index, 1)
    },

    scrollToPanel(index) {
      this.$nextTick(() => {
        const panel = this.$refs[`fallback-${index}`]
        if (panel) {
          panel.toggle()
          const fallbackElement = document.getElementById(`fallback-${index}`)
          if (fallbackElement) {
            fallbackElement.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            })
          }
        }
      })
    },

    removeFallback(index) {
      this.remove(index)
      this.scrollToPanel(index - 1)
    }
  },

  render
}
